import React, { useEffect } from 'react';
import RouteConstants from '../../constants/routeConstants';
import {
    Box,
    // CircularProgress,
    Slide,
} from '@mui/material';
import { useState, Downgraded } from '@hookstate/core';
import AccordianCommonRequests from '../../sharedcomponents/commonRequest/accordianCommonRequest';
import { useEventState } from '../../stores/eventStore';
import { generatePath } from 'react-router-dom';
import Helper from '../../utility/helper';
import {
    NO_ACCESS_PERMISSION,
    FULL_PERMISSION, REQUEST_STATUS_LIST
} from '../../constants/Constant';
import UnauthorizedUI from '../../sharedcomponents/emptyStateContainer/unauthorizedUI';
import CustomizedSnackbars from '../../sharedcomponents/snackbar/snackBar';
import ConfirmationDialog from '../../sharedcomponents/confirmationdialog/confirmationDialog';
import APIURLConstants from '../../config/config';
import ApiHelper from '../../utility/ApiHelper';
import AppConstants from '../../constants/appConstants';
import { useHistory } from 'react-router-dom';
import AdminNote from '../../sharedcomponents/adminNote/adminNote';
import StyledTable1 from '../../sharedcomponents/styledTable/styleTable1';
import CustomDialog from '../../sharedcomponents/dialog/dialog';
import PendingActionDialog from '../../sharedcomponents/confirmationdialog/pendingActionDialog';

// const loader = {
//     display: 'flex',
//     justifyContent: 'center',
//     alignItems: 'center',
//     height: '100%',
//     width: '100%',
// };
const Ticket = (props) => {
    const showSearch = true;
    const history = useHistory();
    const loading = useState(false);
    const allData = useState([]);
    const eventData = useState(null);
    const eventState = useEventState();
    const [modPermission, setModPermission] = React.useState(null);
    const [filters, setFilters] = React.useState(null);
    const statusList = useState(REQUEST_STATUS_LIST);
    const setAll = useState(false);
    const displayName = useState(null);
    const filteredEmty = useState(false);
    const fullData = useState([]);
    const [showSearchRec, setShowSearchRec] = React.useState(false);
    const requestPending = useState(null);
    const userID = useState(null);
    const openNoteDialog = useState(false);
    const requestNote = useState(null);
    const filteredList = useState([]);
    const [filterChangeVal, setFilterChangeVal] = React.useState(false);
    const [participantList, setParticipantList] = React.useState(null);
    const allNote = useState(false);
    const [allNoteValue, setAllNoteValue] = React.useState('')
    const [showStatus, setShowStatus] = React.useState({
        Approved: 0,
        Pending: 0,
        Rejected: 0,
    });
    const [snackBarProps, setSnackBarProps] = React.useState({
        openSnack: false,
        variant: 'error',
        message: '',
    });
    const pendingAction = useState({
        open: false,
        title: '',
        message: '',
    });
    const deleteConfirmation = useState({
        open: false,
        title: '',
        message: '',
    });
    const pagingInfo = useState({
        currentPage: 1,
        itemsPerPage: 5000,
        noOfPages: null,
    });
    const approveConfirmation = useState({
        open: false,
        title: '',
        message: '',
    });
    const rejectConfirmation = useState({
        open: false,
        title: '',
        message: '',
    });
    const approveloading = useState({
        loading: false,
        index: 0
    })
    const rejectloading = useState({
        loading: false,
        index: 0
    })
    const [ticketHistory, setTicketHistory] = React.useState();
    const [showHistory, setShowHistory] = React.useState(false);
    const approveLoader = useState(false);
    const rejectLoader = useState(false);

    useEffect(() => {
        const eventInfo = Helper.getStorage('eventInfo');
        if (
            eventData.get() == null ||
            (eventData.get() && eventData.eventID.value != eventInfo.eventID)
        ) {
            eventData.set(eventInfo);
            eventInfo.moduleDetails.filter((x) => x.moduleID === AppConstants.EVENT_MODULES.DRAFT_TICKET).map((item) => {
                displayName.set(item.displayName)
            })
        }

    }, []);

    useEffect(() => {
        const userInfo = Helper.getStorage('userInfo');
        if (eventState && eventState.eventDetail.get()) {
            if (Helper.isAdminUser(userInfo) || Helper.isEventAdmin(userInfo) || Helper.isEventStaff(userInfo)) {
                setModPermission(FULL_PERMISSION);
                userID.set(userInfo.userID);
            } else if (userInfo.roles) {
                const permissions = eventState.permissions
                    .attach(Downgraded)
                    .get();
                userID.set(userInfo.userID);
                if (permissions && permissions.length > 0) {
                    setModPermission(
                        Helper.getModuleAccessPermission(permissions, 'TICKET')
                    );
                }
            }
        }
    }, [eventState]);
    useEffect(() => {
        if (modPermission && modPermission != NO_ACCESS_PERMISSION) {
            // const pageInfo = pagingInfo.attach(Downgraded).get();
            // if (pageInfo.itemsPerPage)
            // {
            //     getTickets();
            //     getParticipantList();
            // }
            getParticipantList();
            getTickets();
        }
    }, [modPermission]);
    const getTickets = () => {
        loading.set(true);
        const userInfo = Helper.getStorage('userInfo');
        let participantList = [];
        ApiHelper.get(
            APIURLConstants.GET_TICKETS(
                eventData.get().eventID,
                true,
                userInfo.userID
            )
        )
            .then((res) => {
                let requestData = [];
                let data = res.data;
                let allRequestData = [];
                const indexOfLastRecord = pagingInfo.get().currentPage * pagingInfo.get().itemsPerPage;
                const indexOfFirstRecord = indexOfLastRecord - pagingInfo.get().itemsPerPage;
                if (data.length > 0) {
                    let approved = 0;
                    let pending = 0;
                    let rejected = 0;
                    data.map((item) => {
                        if (item.requestStatus === 'Approved') {
                            approved += 1;
                        } else if (item.requestStatus === 'Pending') {
                            pending += 1;
                        } else {
                            rejected += 1;
                        }
                        if (participantList.indexOf(item.participant) == -1) {
                            participantList.push(item.participant);
                        }
                        allRequestData.push({
                            actualData: item,
                            row: [
                                {
                                    label: 'checkbox',
                                    key: 'ticketID',
                                    ticketID: item.ticketID,
                                    width: '0.05',
                                    inColumn: true,
                                    alignCenter: true,
                                },
                                {
                                    label: 'Participant',
                                    key: 'participant',
                                    participant: item.participant,
                                    width: '0.25',
                                    showLabel: false,
                                    toEmail: item.email,
                                    showEmail: true,
                                },

                                {
                                    label: 'Submitted By',
                                    key: 'createdBy',
                                    createdBy: item.createdByName,
                                    width: '0.25',
                                    inColumn: true,
                                },

                                {
                                    label: 'Submitted Date',
                                    key: 'createdDate',
                                    createdDate: !Helper.IfDateIsNULL(
                                        item.createdDate
                                    )
                                        ? Helper.FormatDate(item.createdDate) +
                                        ' ' +
                                        Helper.FormatTime(item.createdDate)
                                        : '',
                                    width: '0.25',
                                    inColumn: true,
                                },
                                {
                                    label: 'Total Tickets',
                                    key: 'totalTickets',
                                    totalTickets: String(item.totalTickets),
                                    width: '0.25',
                                    inColumn: true,
                                    alignCenter: true,
                                },
                                {
                                    label: 'History',
                                    key: 'auditHistory',
                                    auditHistory: '',
                                    width: '0.05',
                                    showLabel: false,
                                    showChips: false,
                                    inColumn: true,
                                },

                                {
                                    label: 'Status',
                                    key: 'requestStatus',
                                    requestStatus: item.requestStatus,
                                    width: '0.10',
                                    showStatusIcon: true,
                                    inColumn: true,
                                    alignCenter: true,
                                },

                                {
                                    label: 'Action',
                                    key: 'All',
                                    all: 'All',
                                    width: '0.15',
                                    inColumn: true,
                                    alignCenter: true,
                                },
                            ],
                            selected: false,
                        });
                    });
                    data.slice(indexOfFirstRecord, indexOfLastRecord).map((item) => {
                        requestData.push({
                            actualData: item,
                            row: [
                                {
                                    label: 'checkbox',
                                    key: 'ticketID',
                                    ticketID: item.ticketID,
                                    width: '0.05',
                                    inColumn: true,
                                    alignCenter: true,
                                },
                                {
                                    label: 'Participant',
                                    key: 'participant',
                                    participant: item.participant,
                                    width: '0.25',
                                    showLabel: false,
                                    toEmail: item.email,
                                    showEmail: true,
                                },

                                {
                                    label: 'Submitted By',
                                    key: 'createdBy',
                                    createdBy: item.createdByName,
                                    width: '0.25',
                                    inColumn: true,
                                },

                                {
                                    label: 'Submitted Date',
                                    key: 'createdDate',
                                    createdDate: !Helper.IfDateIsNULL(
                                        item.createdDate
                                    )
                                        ? Helper.FormatDate(item.createdDate) +
                                        ' ' +
                                        Helper.FormatTime(item.createdDate)
                                        : '',
                                    width: '0.25',
                                    inColumn: true,
                                },
                                {
                                    label: 'Total Tickets',
                                    key: 'totalTickets',
                                    totalTickets: String(item.totalTickets),
                                    width: '0.25',
                                    inColumn: true,
                                    alignCenter: true,
                                },
                                {
                                    label: 'History',
                                    key: 'auditHistory',
                                    auditHistory: '',
                                    width: '0.05',
                                    showLabel: false,
                                    showChips: false,
                                    inColumn: true,
                                },

                                {
                                    label: 'Status',
                                    key: 'requestStatus',
                                    requestStatus: item.requestStatus,
                                    width: '0.10',
                                    showStatusIcon: true,
                                    inColumn: true,
                                    alignCenter: true,
                                },

                                {
                                    label: 'Action',
                                    key: 'All',
                                    all: 'All',
                                    width: '0.15',
                                    inColumn: true,
                                    alignCenter: true,
                                },
                            ],
                            selected: false,
                        });
                    });
                    fullData.set(allRequestData)
                    setFilters({
                        participant: participantList,
                        requestStatus: statusList.attach(Downgraded).get(),
                    })
                    setShowStatus({
                        Approved: approved,
                        Pending: pending,
                        Rejected: rejected,
                    });
                } else {
                    setShowStatus({ Approved: 0, Pending: 0, Rejected: 0 });
                }
                setShowSearchRec(false);
                let filterData = filteredList.attach(Downgraded).get();
                if (filterData.length > 0) {
                    setFilterChangeVal(false);
                }
                allData.set(requestData);
                loading.set(false);

                if (pagingInfo.get().noOfPages == null) {
                    pagingInfo.set({
                        ...pagingInfo,
                        currentPage: pagingInfo.get().currentPage,
                        itemsPerPage: pagingInfo.get().itemsPerPage,
                        noOfPages: Math.ceil(
                            res.data.totalCount / pagingInfo.get().itemsPerPage
                        ),
                    });
                }
                loading.set(false);
            })
            .catch((error) => {
                loading.set(false);
                if (error.response && error.response.status === 401) {
                    alert(error);
                }
            });
    };
    const onDelete = () => {
        const selected = allData.attach(Downgraded).get().filter((user) => user.selected === true);
        const selected1 = fullData.attach(Downgraded).get().filter((user) => user.selected === true);
        if (selected.length === 0 && selected1.length === 0) {
            setSnackBarProps({
                ...snackBarProps,
                openSnack: true,
                variant: 'error',
                message: 'Please select Ticket first',
            });
        } else {
            let message = setAll.get()
                ? 'Do you want to delete all Ticket?'
                : 'Do you want to delete selected Ticket?';

            deleteConfirmation.set({
                open: true,
                title: '',
                OkButtonText: 'Ok',
                message: message,
            });
        }
    };
    const closeNoteDialog = () => {
        approveloading.set({
            loading: false,
            index: 0
        })
        rejectloading.set({
            loading: false,
            index: 0
        })
        openNoteDialog.set(false);
        requestNote.set(null);
    };
    const getParticipantList = () => {
        const gUserInfo = Helper.getStorage('userInfo');
        const gEventInfo = Helper.getStorage('eventInfo');
        if (
            Helper.isAdminUser(gUserInfo) ||
            (gUserInfo.roles && Helper.isEventAdmin(gUserInfo)) || (gUserInfo.roles && Helper.isEventStaff(gUserInfo))
        ) {
            ApiHelper.get(
                APIURLConstants.GET_ADMIN_EVENT_PARTICIPANTS(gEventInfo.eventID)
            ).then((res) => {
                if (res.data.rows) {
                    const participants = res.data.rows.filter(
                        (participant) =>
                            AppConstants.EVENT_ROLES_VALUES.indexOf(
                                participant.roleName
                            ) == -1
                    );
                    setParticipantList(participants);
                }
            });
        }
    };

    const onAddRequest = () => {
        let registeredIds = allData
            .attach(Downgraded)
            .get()
            .map((x) => x.actualData.userID);
        let filteredParticipants = participantList.filter(
            (x) => !registeredIds.includes(x.userID)
        );
        props.history.push({
            pathname: generatePath(RouteConstants.CREATE_EVENT_TICKET, {
                eventID: eventData.get().eventID,
            }),
            state: { ticketID: '', participantList: filteredParticipants },
        });
    };
    const redirectToEdit = (data) => {
        const row = data.actualData;
        let registeredIds = allData
            .attach(Downgraded)
            .get()
            .map((x) => x.actualData.userID);
        let index = registeredIds.indexOf(row.userID);
        registeredIds.splice(index, 1);
        let filteredParticipants = participantList.filter(
            (x) => !registeredIds.includes(x.userID)
        );
        const path = generatePath(RouteConstants.EDIT_EVENT_TICKET, {
            eventID: eventData.get().eventID,
            ticketID: row.ticketID,
        });
        history.push({
            pathname: path,
            state: { ticketState: row, participantList: filteredParticipants },
        });
    };
    const handleConfirmation = () => {
        const gUserInfo = Helper.getStorage('userInfo');
        let deleteRequests = [];
        allData.attach(Downgraded).get().map((row) => {
            if (row.selected === true) {
                deleteRequests.push(row.actualData.ticketID);
            }
        });
        fullData.attach(Downgraded).get().map((row) => {
            if (row.selected === true) {
                deleteRequests.push(row.actualData.ticketID);
            }
        });
        ApiHelper.post(APIURLConstants.DELETE_TICKETS, {
            ticketIDs: deleteRequests.join(','),
            modifiedBy: gUserInfo.userID,
        })
            .then((res) => {
                if (res.data) {
                    setSnackBarProps({
                        ...snackBarProps,
                        openSnack: true,
                        variant: 'success',
                        message: 'Request deleted successfully',
                    });
                    setAll.set(false);
                    getTickets();
                } else {
                    setSnackBarProps({
                        ...snackBarProps,
                        openSnack: true,
                        variant: 'error',
                        message: 'Something went wrong while deleting tickets',
                    });

                    setAll.set(false);
                }
            })
            .catch((error) => {
                let message = '';
                if (error.response && error.response.status === 401) {
                    message = 'Access denied';
                } else {
                    message = 'Error while deleting request';
                }
                setSnackBarProps({
                    ...snackBarProps,
                    openSnack: true,
                    variant: 'error',
                    message: message,
                });
            });
        deleteConfirmation.set({
            open: false,
            title: '',
            OkButtonText: 'Ok',
            message: '',
        });
    };
    const onActionClick = (item, index, action) => {
        if (action == 'Approve') {
            approveloading.set({
                loading: true,
                index: index
            })
        }
        else if (action == 'Reject') {
            rejectloading.set({
                loading: true,
                index: index
            })
        }
        let newData = [...allData.attach(Downgraded).get()];
        let Index = newData.findIndex(
            (data) => data.actualData.ticketID == item.actualData.ticketID
        );
        let newItem = newData[Index];

        const isStatus = action == 'Approve' ? 2 : action == 'Reject' ? 3 : 1;
        requestNote.set({
            ticketID: newItem.actualData.ticketID,
            status: isStatus,
            userID: item.actualData.userID,
            action,
            note: newItem.note,
            item: item,
        });
        openNoteDialog.set(true);
    };
    const onPendingAction = (item, index) => {
        if (item.actualData.requestStatus == 'Approved') {
            approveloading.set({
                loading: true,
                index: index
            })
        }
        else if (item.actualData.requestStatus == 'Rejected') {
            rejectloading.set({
                loading: true,
                index: index
            })
        }
        let newData = [...allData.attach(Downgraded).get()];
        let Index = newData.findIndex(
            (data) => data.actualData.ticketID == item.actualData.ticketID
        );
        let newItem = newData[Index].actualData;

        const isStatus = 1;
        requestPending.set({
            status: isStatus,
            userID: item.actualData.userID,
            ticketID: newItem.ticketID,
            item: item,
        });

        let message = 'Do you want to move request to pending?';

        pendingAction.set({
            open: true,
            title: '',
            OkButtonText: 'Ok',
            message: message,
        });
    };
    const handlePendingAction = async () => {
        pendingAction.set({
            open: false,
            title: '',
            OkButtonText: 'Ok',
            message: '',
        });
        const newRequestNote = requestPending.attach(Downgraded).get();
        const userInfo = Helper.getStorage('userInfo');

        const updateStatus = {
            eventID: eventData.get().eventID,
            ticketID: newRequestNote.ticketID,
            modifiedBy: newRequestNote.userID,
            status: 1,
        };
        const emailData = {
            ticketID: parseInt(newRequestNote.ticketID),
            eventID: eventData.get().eventID,
            userID: newRequestNote.userID,
            participant: newRequestNote.item.actualData.participant,
            receipentName: newRequestNote.item.actualData.receipentName,
            receipentEmail: newRequestNote.item.actualData.receipentEmail,
            receipentContact: newRequestNote.item.actualData.receipentContact,
            requestStatus: 'Pending',
            note: newRequestNote.item.actualData.note,
            totalTickets: newRequestNote.item.actualData.totalTickets,
            createdBy: userInfo.userID,
        };
        ApiHelper.post(APIURLConstants.UPDATE_EVENT_STATUS, updateStatus).then(
            async (res) => {
                if (res.data) {
                    rejectloading.set({
                        loading: false,
                        index: 0
                    })
                    approveloading.set({
                        loading: false,
                        index: 0
                    })
                    pendingAction.set({
                        open: false,
                        title: '',
                        OkButtonText: 'Ok',
                        message: '',
                    });
                    requestPending.set(null);
                    setSnackBarProps({
                        ...snackBarProps,
                        openSnack: true,
                        variant: 'success',
                        message: 'Request updated successfully',
                    });
                    getTickets();
                    let published = {}
                    participantList.filter((item) => item.userID === emailData.userID).map((x) => {
                        published = { isPublished: x.isPublished }
                    })
                    //             if(published.isPublished){
                    // await sendEmailNotification(emailData);
                    //             }
                }
            }
        );
    };
    const updateNote = async (value) => {
        let newRequestNote = { ...requestNote.attach(Downgraded).get() };
        newRequestNote['note'] = value;
        const userInfo = Helper.getStorage('userInfo');
        const statusUpdate = {
            eventID: eventData.get().eventID,
            ticketID: newRequestNote.ticketID,
            modifiedBy: newRequestNote.userID,
            status: newRequestNote.status,
            note: newRequestNote.note,
        };
        const emailData = {
            ticketID: parseInt(newRequestNote.ticketID),
            eventID: eventData.get().eventID,
            userID: newRequestNote.userID,
            participant: newRequestNote.item.actualData.participant,
            receipentName: newRequestNote.item.actualData.receipentName,
            receipentEmail: newRequestNote.item.actualData.receipentEmail,
            receipentContact: newRequestNote.item.actualData.receipentContact,
            requestStatus:
                newRequestNote.status == 2
                    ? 'Approved'
                    : newRequestNote.status == 3
                        ? 'Rejected'
                        : 'Pending',
            note: newRequestNote.note,
            totalTickets: newRequestNote.item.actualData.totalTickets,
            createdBy: userInfo.userID,
        };

        ApiHelper.post(APIURLConstants.UPDATE_EVENT_STATUS, statusUpdate)
            .then(async (result) => {
                if (result.data) {
                    approveloading.set({
                        loading: false,
                        index: 0
                    })
                    rejectloading.set({
                        loading: false,
                        index: 0
                    })
                    setSnackBarProps({
                        ...snackBarProps,
                        openSnack: true,
                        variant: 'success',
                        message: 'Status updated successfully',
                    });
                    await getTickets();
                    let published = {}
                    participantList.filter((item) => item.userID === newRequestNote.item.actualData.userID).map((x) => {
                        published = { isPublished: x.isPublished }
                    })
                    //             if(published.isPublished){
                    // await sendEmailNotification(emailData);
                    //             }
                    if (eventData.get().readonlyOrHide === 0 && published.isPublished) {
                        await saveAppNotification(newRequestNote);
                    }
                    await closeNoteDialog();
                }
            })
            .catch((err) => {
                approveloading.set({
                    loading: false,
                    index: 0
                })
                rejectloading.set({
                    loading: false,
                    index: 0
                })
                console.log(err);
            });
    };
    const saveAppNotification = (obj) => {
        let payLoad = {
            appNotificationID: 0,
            userIDs: JSON.stringify(obj.userID),
            appNotificationTypeID: 1,
            eventID: eventData.get().eventID,
            moduleID: 8,
            recordRefID: obj.ticketID,
            requestStatus: obj.status,
            status: 0,
            createdBy: userID.get(),
        };
        ApiHelper.post(APIURLConstants.SAVE_APP_NOTIFICATION, payLoad)
            .then((res) => {
                ApiHelper.get(
                    APIURLConstants.GET_MOBILE_PUSH_NOTIFICATION(
                        obj.userID,
                        eventData.get().eventID,
                        eventData.get().eventName,
                        displayName.get(),
                        obj.status === 2 ? "Approved" : obj.status === 3 ? "Rejected" : "Pending"
                    )
                ).then((res) => {
                    console.log(res);
                });
            })
            .catch((err) => {
                console.log(err);
            });
    };
    const hanldeAllNoteValue = (item) => {
        setAllNoteValue(item)
    }
    // const sendEmailNotification = (data) =>
    // {
    //     return ApiHelper.post(
    //         APIURLConstants.SEND_TICKET_EMAIL_NOTIFICATION,
    //         data
    //     )
    //         .then((result) =>
    //         {
    //             return result.data;
    //         })
    //         .catch((err) =>
    //         {
    //             console.log(err);
    //         });
    // };
    const filterListData = (data) => {
        if (data.length == 0) {
            filteredEmty.set(true);
        } else {
            filteredEmty.set(false);
        }
        filteredList.set(data);
    };

    const renderDialogActions = () => { };
    const Transition = React.forwardRef(function Transition(props, ref) {
        return <Slide direction="up" ref={ref} {...props} />;
    });
    const renderDialogContent = () => {
        return <StyledTable1 rowHeader={headers} data={ticketHistory} />;
    };
    const showTicketHistory = (item) => {
        setShowHistory(true);
        getTicketHistory(item.actualData.ticketID);
    };
    const headers = [
        { key: 'participant', title: 'Participant' },
        { key: 'ticketContactName', title: 'Ticket Contact Name' },
        { key: 'ticketContactEmail', title: 'Ticket Contact Email' },
        { key: 'ticketContactNumber', title: 'Ticket Contact Number' },
        { key: 'totalTicket', title: 'Total Tickets' },
        { key: 'submittedBy', title: 'Audit By' },
        { key: 'auditStatus', title: 'Audit Status' },
        { key: 'submittedDate', title: 'Audit Date' },
        { key: 'requestStatus', title: 'Status' },
    ];
    const getTicketHistory = (id) => {
        ApiHelper.get(APIURLConstants.GET_TICKET_HISTORY(id)).then((res) => {
            setTicketHistory([]);
            let arr = [];
            res.data.map((item, index, originalArr) => {
                let previous = originalArr[index - 1];
                arr.push({
                    actualData: item,
                    row: [
                        {
                            participant: item.participant,
                            highlight:
                                index > 0
                                    ? previous?.participant !== item.participant
                                        ? true
                                        : false
                                    : false,
                        },
                        {
                            ticketContactName: item.receipentName,
                            highlight:
                                index > 0
                                    ? previous?.receipentName !==
                                        item.receipentName
                                        ? true
                                        : false
                                    : false,
                        },
                        {
                            ticketContactEmail: item.receipentEmail,
                            highlight:
                                index > 0
                                    ? previous?.receipentEmail !==
                                        item.receipentEmail
                                        ? true
                                        : false
                                    : false,
                        },
                        {
                            ticketContactNumber: item.receipentContact,
                            highlight:
                                index > 0
                                    ? previous?.receipentContact !==
                                        item.receipentContact
                                        ? true
                                        : false
                                    : false,
                        },
                        {
                            totalTicket: item.totalTickets,
                            highlight:
                                index > 0
                                    ? previous?.totalTickets !==
                                        item.totalTickets
                                        ? true
                                        : false
                                    : false,
                        },
                        {
                            submittedBy: item.submittedBy
                                ? item.submittedBy
                                : '',
                            highlight:
                                index > 0
                                    ? previous?.submittedBy !== item.submittedBy
                                        ? true
                                        : false
                                    : false,
                        },
                        {
                            auditStatus: item.auditStatus
                                ? item.auditStatus
                                : '',
                            highlight:
                                index > 0
                                    ? previous?.auditStatus !== item.auditStatus
                                        ? true
                                        : false
                                    : false,
                        },
                        {
                            submittedDate: item.submittedDate
                                ? Helper.FormatDateTime(item.submittedDate)
                                : '',
                            highlight:
                                index > 0
                                    ? previous?.submittedDate !==
                                        item.submittedDate
                                        ? true
                                        : false
                                    : false,
                        },

                        {
                            requestStatus: item.requestStatus
                                ? item.requestStatus
                                : '',
                            highlight:
                                index > 0
                                    ? previous?.requestStatus !==
                                        item.requestStatus
                                        ? true
                                        : false
                                    : false,
                        },
                    ],
                });
            });
            setTicketHistory(arr);
        });
    };
    const onSettingClick = () => {
        props.history.push({
            pathname: generatePath(RouteConstants.EVENT_TICKET_SETTINGS, {
                eventID: eventData.get().eventID,
            }),
        });
    };
    const generateExcelReport = async (result) => {
        let selectedIds = [];
        let IDs = null;
        if (result.length > 0) {
            result.map((item) => {
                selectedIds.push(item.actualData.ticketID);
            });
            IDs = selectedIds.join(',');
        }

        await ApiHelper.post(
            APIURLConstants.Excel_Export, { EventID: eventData.get().eventID, ModuleID: 8, IDs: IDs }
        ).then((res) => {
            const finalObject = JSON.parse(res.data.value);
            if (finalObject) {
                if (finalObject.length > 0) {
                    let header = {};
                    Object.keys(finalObject[0]).map((key) => {
                        header[key] = key;
                    });

                    finalObject.unshift(header);
                    Helper.downloadReport(finalObject, `Ticket-Report`);
                }
            }
        });
    };
    const callExport = () => {
        if (filteredList.attach(Downgraded).length !== 0) {
            const selected = filteredList
                .get()
                .filter((user) => user.selected === true);
            const allSelected = filteredList
                .get()
                .filter((user) => user.selected === false);

            if (selected.length === 0) {
                generateExcelReport(allSelected);
            } else {
                generateExcelReport(selected);
            }
        } else {
            const selected = allData
                .get()
                .filter((user) => user.selected === true);
            const allSelected = fullData
                .get()
                .filter((user) => user.selected === false);

            if (selected.length === 0) {
                generateExcelReport(allSelected);
            } else {
                generateExcelReport(selected);
            }
        }
    };
    const multiApprove = () => {
        const selected = allData
            .attach(Downgraded)
            .get()
            .filter((user) => user.selected === true);
        const selected1 = fullData.attach(Downgraded).get().filter((user) => user.selected === true);
        if (selected.length === 0 && selected1.length === 0) {
            setSnackBarProps({
                ...snackBarProps,
                openSnack: true,
                variant: 'error',
                message: 'Please select request first',
            });
        } else {
            let message = setAll.get()
                ? 'Do you want to Approve all request?'
                : 'Do you want to Approve selected request?';
            allNote.set(true)
            approveConfirmation.set({
                open: true,
                title: '',
                OkButtonText: 'Ok',
                message: message,
            });
        }
    };
    const multiReject = () => {
        const selected = allData
            .attach(Downgraded)
            .get()
            .filter((user) => user.selected === true);
        const selected1 = fullData.attach(Downgraded).get().filter((user) => user.selected === true);
        if (selected.length === 0 && selected1.length === 0) {
            setSnackBarProps({
                ...snackBarProps,
                openSnack: true,
                variant: 'error',
                message: 'Please select request first',
            });
        } else {
            let message = setAll.get()
                ? 'Do you want to Reject all request?'
                : 'Do you want to Reject selected request?';
            allNote.set(true)
            rejectConfirmation.set({
                open: true,
                title: '',
                OkButtonText: 'Ok',
                message: message,
            });
        }
    };
    // const getMultiEmailNotification = async (multiUsers, requestIds) =>
    // {
    //     const eventInfo = Helper.getStorage('eventInfo');
    //     multiUsers.map((user, index) =>
    //     {
    //         let form = new FormData();
    //         form.append('UserID', user);
    //         form.append('EventID', eventInfo.eventID)
    //         form.append('TemplateType', 'Ticket')
    //         form.append('ID', requestIds[index])
    //         form.append('ModifyBy', userID.value)
    //         form.append('TranportType', 'Ticket')
    //         form.append('ModuleID', 8)
    //         return ApiHelper.post(
    //             APIURLConstants.POST_EMAIL_NOTIFICATION,
    //             form
    //         )
    //             .then((result) =>
    //             {
    //                 return result.data;
    //             })
    //             .catch((err) =>
    //             {
    //                 console.log(err);
    //             });
    //     })
    // }
    // const multisaveAppNotification = (multiUsers, requestIds, status) =>
    // {
    //     multiUsers.map((user, index) =>
    //     {
    //         let payLoad = {
    //             appNotificationID: 0,
    //             userIDs: JSON.stringify(user),
    //             appNotificationTypeID: 1,
    //             eventID: eventData.get().eventID,
    //             moduleID: 8,
    //             recordRefID: requestIds[index],
    //             requestStatus: status,
    //             status: 0,
    //             createdBy: userID.get(),
    //         };
    //         ApiHelper.post(APIURLConstants.SAVE_APP_NOTIFICATION, payLoad).then(res =>
    //         {console.log(res)
    //             ApiHelper.get(
    //                 APIURLConstants.GET_MOBILE_PUSH_NOTIFICATION(
    //                     user,
    //                     eventData.get().eventID,
    //                     eventData.get().eventName,
    //                     displayName.get(),
    //                     status === 2 ? "Approved" : status === 3 ? "Rejected" : "Pending"
    //                 )
    //             ).then((res) =>
    //             {
    //                 console.log(res);
    //             });
    //         }).catch(err =>
    //         {
    //             console.log(err);
    //         })
    //     })
    // }
    const handleRejectConfirmation = () => {
        let allRejectRequests = [];
        // let rejectRequests = [];
        // let multiUsers = [];
        allData.get().map((row) => {
            if (row.selected === true) {
                allRejectRequests.push({
                    userID: row.actualData.userID,
                    iD: row.actualData.ticketID,
                    transportType: 'Tickets'
                });
            }
        });
        // fullData.get().map((row) =>
        // {
        //     if (row.selected === true)
        //     {
        //         allRejectRequests.push({
        //             userID:row.actualData.userID,
        //                 iD:row.actualData.ticketID,
        //                 transportType :'Tickets'});
        //     }
        // });
        // console.log(allData.get())
        // allData.get().filter((elem) => {
        //     return participantList.some((ele) => {
        //     return elem.selected===true && ele.userID === elem.actualData.userID && ele.isPublished;
        //       })}).map((row) =>
        // {
        //         rejectRequests.push(row.actualData.ticketID);
        //         multiUsers.push(row.actualData.userID);
        // });
        // fullData.get().filter((elem) => {
        //     return participantList.some((ele) => {
        //     return elem.selected===true && ele.userID === elem.actualData.userID && ele.isPublished;
        //       })}).map((row) =>
        // {
        //         rejectRequests.push(row.actualData.ticketID);
        //         multiUsers.push(row.actualData.userID);
        // });
        rejectLoader.set(true)
        const eventInfo = Helper.getStorage('eventInfo');
        ApiHelper.post(APIURLConstants.UPDATE_MULTI_SELECT_STATUS, {
            Ids: JSON.stringify(allRejectRequests),
            Status: 3,
            Note: allNoteValue,
            EventID: eventInfo.eventID,
            ModuleID: 8,
            ModifiedBy: userID.value,
            TemplateType: "Tickets",
            TransportType: "Tickets",
            appNotificationTypeID: 1
        })
            .then((res) => {
                if (res.data) {
                    rejectLoader.set(false)
                    setSnackBarProps({
                        ...snackBarProps,
                        openSnack: true,
                        variant: 'success',
                        message: 'Request rejected successfully',
                    });
                    setAll.set(false);
                    getTickets();
                    setAllNoteValue("")
                    // console.log(multiUsers)
                    // console.log(rejectRequests)
                    // getMultiEmailNotification(multiUsers, rejectRequests)
                    // if (eventInfo.readonlyOrHide === 0)
                    // {
                    //     multisaveAppNotification(multiUsers, rejectRequests, 3);
                    // }
                }
            })
            .catch((error) => {
                rejectLoader.set(false)
                if (error.response && error.response.status === 401) {
                    let message = 'Access denied';
                    setSnackBarProps({
                        ...snackBarProps,
                        openSnack: true,
                        variant: 'error',
                        message: message,
                    });
                } else if (error.response && error.response.status === 502) {
                    let message = 'Request rejected successfully';
                    setSnackBarProps({
                        ...snackBarProps,
                        openSnack: true,
                        variant: 'success',
                        message: message,
                    });
                } else {
                    let message = 'Error while reject request';
                    setSnackBarProps({
                        ...snackBarProps,
                        openSnack: true,
                        variant: 'error',
                        message: message,
                    });
                }
            });
        rejectConfirmation.set({
            open: false,
            title: '',
            OkButtonText: 'Ok',
            message: '',
        });
    };
    const handleApproveConfirmation = () => {
        let allApproveRequests = [];
        // let approveRequests = [];
        // let multiUsers = [];
        allData.get().map((row) => {
            if (row.selected === true) {
                allApproveRequests.push({
                    userID: row.actualData.userID,
                    iD: row.actualData.ticketID,
                    transportType: 'Tickets'
                });
            }
        });
        // fullData.get().map((row) =>
        // {
        //     if (row.selected === true)
        //     {
        //         allApproveRequests.push({
        //             userID:row.actualData.userID,
        //                 iD:row.actualData.ticketID,
        //                 transportType :'Tickets'});
        //     }
        // });
        // allData.get().filter((elem) => {
        //     return participantList.some((ele) => {
        //     return elem.selected===true && ele.userID === elem.actualData.userID && ele.isPublished;
        //       })}).map((row) =>
        // {
        //     approveRequests.push(row.actualData.ticketID);
        //         multiUsers.push(row.actualData.userID);
        // });
        // fullData.get().filter((elem) => {
        //     return participantList.some((ele) => {
        //     return elem.selected===true && ele.userID === elem.actualData.userID && ele.isPublished;
        //       })}).map((row) =>
        // {
        //     approveRequests.push(row.actualData.ticketID);
        //         multiUsers.push(row.actualData.userID);
        // });
        approveLoader.set(true)
        const eventInfo = Helper.getStorage('eventInfo');
        ApiHelper.post(APIURLConstants.UPDATE_MULTI_SELECT_STATUS, {
            Ids: JSON.stringify(allApproveRequests),
            Status: 2,
            Note: allNoteValue,
            EventID: eventInfo.eventID,
            ModuleID: 8,
            ModifiedBy: userID.value,
            TemplateType: "Tickets",
            TransportType: "Tickets",
            appNotificationTypeID: 1
        })
            .then((res) => {
                if (res.data) {
                    approveLoader.set(false)
                    setSnackBarProps({
                        ...snackBarProps,
                        openSnack: true,
                        variant: 'success',
                        message: 'Request approved successfully',
                    });
                    setAll.set(false);
                    getTickets();
                    setAllNoteValue("")
                    // getMultiEmailNotification(multiUsers, approveRequests)
                    // if (eventInfo.readonlyOrHide === 0)
                    // {
                    //     multisaveAppNotification(multiUsers, approveRequests, 2);
                    // }
                }
            })
            .catch((error) => {
                approveLoader.set(false)
                if (error.response && error.response.status === 401) {
                    let message = 'Access denied';
                    setSnackBarProps({
                        ...snackBarProps,
                        openSnack: true,
                        variant: 'error',
                        message: message,
                    });
                } else if (error.response && error.response.status === 502) {
                    let message = 'Request approved successfully';
                    setSnackBarProps({
                        ...snackBarProps,
                        openSnack: true,
                        variant: 'success',
                        message: message,
                    });
                } else {
                    let message = 'Error while approve request';
                    setSnackBarProps({
                        ...snackBarProps,
                        openSnack: true,
                        variant: 'error',
                        message: message,
                    });
                }
            });
        approveConfirmation.set({
            open: false,
            title: '',
            OkButtonText: 'Ok',
            message: '',
        });
    };

    return (
        <Box sx={{ width: '100%' }}>
            {
                // loading.get() ? (
                //     <Box style={loader}>
                //         <CircularProgress />
                //     </Box>
                // ) :
                modPermission && modPermission == NO_ACCESS_PERMISSION ? (
                    <UnauthorizedUI showLogout={false} />
                ) : (
                    <AccordianCommonRequests
                        data={allData.attach(Downgraded).get()}
                        allData={fullData.attach(Downgraded).get()}
                        editRow={redirectToEdit}
                        handleClick={onAddRequest}
                        title={''}
                        filterChangeVal={filterChangeVal}
                        loading={loading.get()}
                        buttonTitle={'Add'}
                        deleteRows={onDelete}
                        showSearch={showSearch}
                        searchLabel={'Search'}
                        showFilter={true}
                        filters={filters}
                        showExport={true}
                        showSync={true}
                        showSettings={true}
                        onSettingClick={onSettingClick}
                        getResults={getTickets}
                        showSearchRec={showSearchRec}
                        setShowSearchRec={setShowSearchRec}
                        callExport={callExport}
                        onActionClick={onActionClick}
                        showHistory={showTicketHistory}
                        pagingInfo={pagingInfo.attach(Downgraded).get()}
                        // handlePageChange={handlePageChange}
                        snackBarProps={snackBarProps}
                        setSnackBarProps={setSnackBarProps}
                        onPendingAction={onPendingAction}
                        modPermission={modPermission}
                        filterListData={filterListData}
                        moduleToShow={'Ticket'}
                        moduleDisplayName={Helper.getModuleName(eventData.get() ? eventData.get().moduleDetails : [], AppConstants.EVENT_MODULES.DRAFT_TICKET)}
                        showRequestStatus={showStatus}
                        showApproveAndReject={true}
                        multiApprove={multiApprove}
                        setFilterChangeVal={setFilterChangeVal}
                        multiReject={multiReject}
                        approveLoader={approveLoader.get()}
                        rejectLoader={rejectLoader.get()}
                        approveloading={approveloading.get()}
                        rejectloading={rejectloading.get()}
                    />
                )
            }
            {
                <ConfirmationDialog
                    open={deleteConfirmation.get().open}
                    message={deleteConfirmation.get().message}
                    OkButtonText={deleteConfirmation.get().OkButtonText}
                    handleCnfClick={() =>
                        handleConfirmation(deleteConfirmation)
                    }
                    onCancelClick={() => {
                        deleteConfirmation.set({
                            ...deleteConfirmation.get(),
                            open: false,
                        });
                    }}></ConfirmationDialog>
            }
            {openNoteDialog.get() && (
                <AdminNote
                    open={openNoteDialog.get()}
                    title="Ticket Note"
                    handleClose={closeNoteDialog}
                    updateNote={updateNote}
                    data={requestNote.attach(Downgraded).get()}
                />
            )}
            {
                <PendingActionDialog
                    open={pendingAction.get().open}
                    message={pendingAction.get().message}
                    OkButtonText={pendingAction.get().OkButtonText}
                    handleCnfClick={() => handlePendingAction(pendingAction)}
                    onCancelClick={() => {
                        pendingAction.set({
                            ...pendingAction.get(),
                            open: false,
                        });
                        approveloading.set({
                            loading: false,
                            index: 0
                        })
                        rejectloading.set({
                            loading: false,
                            index: 0
                        })
                    }}></PendingActionDialog>
            }
            {showHistory && (
                <CustomDialog
                    TransitionComponent={Transition}
                    title={'Ticket Booking History'}
                    maxWidth="xl"
                    handleClose={() => {
                        setShowHistory(false);
                        setTicketHistory([]);
                    }}
                    showClose={true}
                    open={showHistory}
                    fullWidth={true}
                    renderContent={renderDialogContent}
                    renderActions={renderDialogActions}
                />
            )}
            {snackBarProps.openSnack && (
                <CustomizedSnackbars
                    {...snackBarProps}
                    onClose={() =>
                        setSnackBarProps({ ...snackBarProps, openSnack: false })
                    }></CustomizedSnackbars>
            )}
            {
                <ConfirmationDialog
                    open={rejectConfirmation.get().open}
                    message={rejectConfirmation.get().message}
                    OkButtonText={rejectConfirmation.get().OkButtonText}
                    note={allNote}
                    allNoteValue={hanldeAllNoteValue}
                    handleCnfClick={() =>
                        handleRejectConfirmation(rejectConfirmation)
                    }
                    fullWidth={true}
                    onCancelClick={() => {
                        rejectConfirmation.set({
                            ...rejectConfirmation.get(),
                            open: false,
                        });
                    }}></ConfirmationDialog>
            }
            {
                <ConfirmationDialog
                    open={approveConfirmation.get().open}
                    message={approveConfirmation.get().message}
                    OkButtonText={approveConfirmation.get().OkButtonText}
                    note={allNote}
                    allNoteValue={hanldeAllNoteValue}
                    handleCnfClick={() =>
                        handleApproveConfirmation(approveConfirmation)
                    }
                    fullWidth={true}
                    onCancelClick={() => {
                        approveConfirmation.set({
                            ...approveConfirmation.get(),
                            open: false,
                        });
                    }}></ConfirmationDialog>
            }
        </Box>
    );
};
export default {
    routeProps: {
        path: RouteConstants.EVENT_TICKETS,
        component: Ticket,
    },
    name: 'Ticket',
};
